import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/dev/icomm/app/(dashboard)/campaigns/page.tsx");
